<div class="step-panel">

  <div class="pg-title" style="margin-bottom: 15px;">
    Financial profile
    <span class="badge b-b" style="vertical-align:middle;margin-left:8px">Step 4</span>
  </div>

  <!-- ══ BANK STATEMENT ANALYZER UPLOAD ══ -->
  <div class="card" style="border-left: 4px solid var(--blue);">
    <div class="card-title">
      <div class="ct-bar" style="background: var(--blue);"></div>
      Bank Statement Analyzer (Auto-fill)
      <span class="ftag ft-auto" style="margin-left:4px">AI Powered</span>
      <span *ngIf="bankStatementData && !isExtractingDoc"
        style="margin-left:auto;font-size:10px;color:var(--green);font-weight:700;">
        ✓ Analysis complete · Data will be saved on Submit
      </span>
    </div>

    <p style="font-size:13px; color:var(--txt2); margin-top:0; margin-bottom:12px;">
      Upload the applicant's bank statement (PDF) to instantly extract bank details, income analysis, and fraud score.
      All extracted data is persisted and visible across all steps — no need to re-upload.
    </p>

    <div class="fl">
      <label class="file-upload-box" [class.disabled]="isExtractingDoc">
        <input type="file" accept=".pdf" (change)="onDocumentUpload($event)"
          [disabled]="isExtractingDoc" hidden />
        <div class="upload-content">
          <i class="bi bi-cloud-arrow-up"></i>
          <div>
            <div class="upload-title">
              {{ selectedFileName || (bankStatementData ? 'Re-upload to refresh analysis' : 'Click to upload Bank Statement') }}
            </div>
            <div class="upload-subtitle">PDF files only · Maximum size 10 MB</div>
          </div>
          <div *ngIf="isExtractingDoc" style="margin-left:auto;display:flex;align-items:center;gap:8px;font-size:12px;color:var(--blue);">
            <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            Analyzing…
          </div>
        </div>
      </label>
    </div>

    <div *ngIf="extractionError"
      style="margin-top:12px;padding:10px;background:#fee2e2;color:#b91c1c;border-radius:6px;font-size:13px;font-weight:500;">
      ⚠️ {{ extractionError }}
    </div>
  </div>

  <!-- ══ BANK STATEMENT DASHBOARD ══ -->
  <ng-container *ngIf="bankStatementData">

    <!-- FILE AUTHENTICITY -->
    <div class="card" style="border-left:4px solid {{ bankStatementData.fileAuth?.fileAuthenticityScore >= 90 ? 'var(--green)' : 'var(--rose)' }};">
      <div class="card-title">
        <div class="ct-bar" style="background:#6366f1;"></div>
        Document Authenticity
        <span *ngIf="bankStatementData.transactionAuthenticity?.tamperingFlagged"
          style="margin-left:8px;background:#fee2e2;color:#b91c1c;padding:3px 10px;border-radius:4px;font-size:11px;font-weight:700;">
          🚨 TAMPERING FLAGGED
        </span>
        <span *ngIf="!bankStatementData.transactionAuthenticity?.tamperingFlagged"
          style="margin-left:8px;background:#d1fae5;color:#065f46;padding:3px 10px;border-radius:4px;font-size:11px;font-weight:700;">
          ✓ Authentic
        </span>
      </div>
      <div class="rg4">
        <div class="rg" [style.background]="(bankStatementData.fileAuth?.fileAuthenticityScore || 0) >= 90 ? 'rgba(5,150,105,0.06)' : 'rgba(225,29,72,0.06)'">
          <div class="rg-l">File Auth Score</div>
          <div class="rg-v" [style.color]="(bankStatementData.fileAuth?.fileAuthenticityScore || 0) >= 90 ? 'var(--green)' : 'var(--rose)'">
            {{ bankStatementData.fileAuth?.fileAuthenticityScore || 0 }}/100
          </div>
          <div class="rg-s">{{ bankStatementData.fileAuth?.pdfProducer || '—' }}</div>
        </div>
        <div class="rg" [style.background]="bankStatementData.transactionAuthenticity?.tamperingFlagged ? 'rgba(225,29,72,0.06)' : 'rgba(5,150,105,0.06)'">
          <div class="rg-l">Txn Auth Score</div>
          <div class="rg-v" [style.color]="bankStatementData.transactionAuthenticity?.tamperingFlagged ? 'var(--rose)' : 'var(--green)'">
            {{ bankStatementData.transactionAuthenticity?.transactionAuthenticityScore || 0 }}/100
          </div>
          <div class="rg-s">Balance continuity failures: {{ bankStatementData.transactionAuthenticity?.balanceContinuityFailureCount || 0 }}</div>
        </div>
        <div class="rg" [style.background]="bankStatementData.riskFraudSignals?.fraudRiskScore > 50 ? 'rgba(225,29,72,0.06)' : 'rgba(5,150,105,0.06)'">
          <div class="rg-l">Fraud Risk Score</div>
          <div class="rg-v" [style.color]="bankStatementData.riskFraudSignals?.fraudRiskScore > 50 ? 'var(--rose)' : 'var(--green)'">
            {{ bankStatementData.riskFraudSignals?.fraudRiskScore || 0 }}/100
          </div>
          <div class="rg-s">{{ bankStatementData.riskFraudSignals?.fraudRiskScore > 50 ? 'High risk' : 'Low risk' }}</div>
        </div>
        <div class="rg">
          <div class="rg-l">Pages / Missing</div>
          <div class="rg-v">{{ bankStatementData.fileAuth?.pageCount || 0 }}</div>
          <div class="rg-s">
            <span *ngIf="bankStatementData.bankStatementIdentity?.missingPagesDetected" style="color:var(--amber);font-weight:600;">⚠ Missing pages</span>
            <span *ngIf="!bankStatementData.bankStatementIdentity?.missingPagesDetected" style="color:var(--green);">✓ Complete</span>
          </div>
        </div>
      </div>

      <!-- Flagged signals row -->
      <div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:10px;"
        *ngIf="bankStatementData.riskFraudSignals?.suspiciousDummyNameTransfer ||
               bankStatementData.riskFraudSignals?.circularTransactionDetected ||
               bankStatementData.riskFraudSignals?.gamblingTransactionCount > 0 ||
               bankStatementData.riskFraudSignals?.cryptoTransactionCount > 0">
        <span *ngIf="bankStatementData.riskFraudSignals?.suspiciousDummyNameTransfer"
          style="background:#fff7ed;color:#c2410c;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;border:1px solid #fed7aa;">
          ⚠️ Suspicious Dummy Name Transfer
        </span>
        <span *ngIf="bankStatementData.riskFraudSignals?.circularTransactionDetected"
          style="background:#fee2e2;color:#991b1b;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;border:1px solid #fecaca;">
          🚨 Circular Transaction
        </span>
        <span *ngIf="bankStatementData.riskFraudSignals?.gamblingTransactionCount > 0"
          style="background:#fee2e2;color:#991b1b;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;border:1px solid #fecaca;">
          🎰 Gambling: {{ bankStatementData.riskFraudSignals?.gamblingTransactionCount }} txn(s)
        </span>
        <span *ngIf="bankStatementData.riskFraudSignals?.cryptoTransactionCount > 0"
          style="background:#fef3c7;color:#92400e;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;border:1px solid #fde68a;">
          ₿ Crypto: {{ bankStatementData.riskFraudSignals?.cryptoTransactionCount }} txn(s)
        </span>
      </div>
    </div>

    <!-- ACCOUNT OVERVIEW -->
    <div class="card">
      <div class="card-title">
        <div class="ct-bar" style="background:#10b981;"></div>
        Account Overview
        <span class="ftag ft-auto" style="margin-left:4px">AI Extracted</span>
      </div>
      <div class="fg c2">
        <div class="fl">
          <label>Bank Name <span class="ftag ft-ro">READ-ONLY</span></label>
          <input class="inp-af inp-ro" type="text" [value]="bankStatementData.bankStatementIdentity?.bankName || '—'" readonly>
        </div>
        <div class="fl">
          <label>Account Holder <span class="ftag ft-ro">READ-ONLY</span></label>
          <input class="inp-af inp-ro" type="text" [value]="bankStatementData.bankStatementIdentity?.accountHolderName || '—'" readonly>
        </div>
        <div class="fl">
          <label>Masked Account No. <span class="ftag ft-ro">READ-ONLY</span></label>
          <input class="inp-af inp-ro" type="text" [value]="bankStatementData.bankStatementIdentity?.maskedAccountNumber || '—'" readonly style="font-family:var(--mono)">
        </div>
        <div class="fl">
          <label>IFSC Code <span class="ftag ft-ro">READ-ONLY</span></label>
          <input class="inp-af inp-ro" type="text" [value]="bankStatementData.bankStatementIdentity?.ifscCode || '—'" readonly style="font-family:var(--mono)">
        </div>
        <div class="fl">
          <label>Account Type <span class="ftag ft-ro">READ-ONLY</span></label>
          <input class="inp-af inp-ro" type="text" [value]="bankStatementData.bankStatementIdentity?.accountType || '—'" readonly>
        </div>
        <div class="fl">
          <label>Statement Period <span class="ftag ft-ro">READ-ONLY</span></label>
          <input class="inp-af inp-ro" type="text"
            [value]="(bankStatementData.bankStatementIdentity?.statementStartDate || '—') + '  →  ' + (bankStatementData.bankStatementIdentity?.statementEndDate || '—')"
            readonly>
        </div>
        <div class="fl">
          <label>Branch Name <span class="ftag ft-ro">READ-ONLY</span></label>
          <input class="inp-af inp-ro" type="text" [value]="bankStatementData.bankStatementIdentity?.branchName || '—'" readonly>
        </div>
        <div class="fl">
          <label>Branch Address <span class="ftag ft-ro">READ-ONLY</span></label>
          <input class="inp-af inp-ro" type="text" [value]="bankStatementData.bankStatementIdentity?.branchAddress || '—'" readonly>
        </div>
      </div>
      <div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:10px;"
        *ngIf="bankStatementData.bankStatementIdentity?.missingPagesDetected || bankStatementData.bankStatementIdentity?.duplicateStatementDetected">
        <span *ngIf="bankStatementData.bankStatementIdentity?.missingPagesDetected"
          style="background:#fef9c3;color:#854d0e;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;">
          ⚠️ Missing Pages Detected
        </span>
        <span *ngIf="bankStatementData.bankStatementIdentity?.duplicateStatementDetected"
          style="background:#fee2e2;color:#991b1b;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;">
          🚨 Duplicate Statement Detected
        </span>
      </div>
    </div>

    <!-- KEY FINANCIAL METRICS -->
    <div class="card">
      <div class="card-title">
        <div class="ct-bar" style="background:#6366f1;"></div>
        Financial Analysis Summary
      </div>

      <div class="rg4">
        <div class="rg gv">
          <div class="rg-l">Total Inflow</div>
          <div class="rg-v">{{ (bankStatementData.creditInflowAnalysis?.totalCreditAmount || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">Avg/mo: {{ (bankStatementData.creditInflowAnalysis?.averageMonthlyCredit || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
        </div>
        <div class="rg av">
          <div class="rg-l">Total Outflow</div>
          <div class="rg-v">{{ (bankStatementData.debitOutflowAnalysis?.totalDebitAmount || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">Avg/mo: {{ (bankStatementData.debitOutflowAnalysis?.averageMonthlyDebit || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
        </div>
        <div class="rg" [style.background]="bankStatementData.salaryIncomeTrust?.salaryDetected ? 'rgba(5,150,105,0.06)' : 'rgba(217,119,6,0.06)'">
          <div class="rg-l">Salary Detected</div>
          <div class="rg-v" [style.color]="bankStatementData.salaryIncomeTrust?.salaryDetected ? 'var(--green)' : 'var(--amber)'">
            {{ bankStatementData.salaryIncomeTrust?.salaryDetected ? 'Yes' : 'No' }}
          </div>
          <div class="rg-s">Income Trust: {{ bankStatementData.salaryIncomeTrust?.incomeTrustScore || 0 }}/100</div>
        </div>
        <div class="rg bv">
          <div class="rg-l">Avg Monthly Balance</div>
          <div class="rg-v">{{ (bankStatementData.balanceHealth?.averageMonthlyBalance || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">Min: {{ (bankStatementData.balanceHealth?.minimumBalance || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
        </div>
      </div>

      <div class="rg4" style="margin-top:10px">
        <div class="rg gv">
          <div class="rg-l">UPI Inflow</div>
          <div class="rg-v">{{ (bankStatementData.upiFlowAnalysis?.totalUpiInflow || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">{{ bankStatementData.upiFlowAnalysis?.upiInflowCount || 0 }} txns</div>
        </div>
        <div class="rg av">
          <div class="rg-l">UPI Outflow</div>
          <div class="rg-v">{{ (bankStatementData.upiFlowAnalysis?.totalUpiOutflow || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">{{ bankStatementData.upiFlowAnalysis?.upiOutflowCount || 0 }} txns</div>
        </div>
        <div class="rg av">
          <div class="rg-l">ATM Withdrawals</div>
          <div class="rg-v">{{ (bankStatementData.cashFlowAnalysis?.cashWithdrawalAmount || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">{{ bankStatementData.cashFlowAnalysis?.cashWithdrawalCount || 0 }} withdrawals</div>
        </div>
        <div class="rg" [style.background]="(bankStatementData.emiLiabilityAnalysis?.existingEmiCount || 0) > 0 ? 'rgba(217,119,6,0.06)' : ''">
          <div class="rg-l">Existing EMIs</div>
          <div class="rg-v">{{ (bankStatementData.emiLiabilityAnalysis?.existingMonthlyEmiAmount || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">{{ bankStatementData.emiLiabilityAnalysis?.existingEmiCount || 0 }} detected</div>
        </div>
      </div>

      <div class="rg4" style="margin-top:10px">
        <div class="rg">
          <div class="rg-l">Wallet Top-ups</div>
          <div class="rg-v">{{ (bankStatementData.upiFlowAnalysis?.paytmWalletTopupAmount || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">{{ bankStatementData.upiFlowAnalysis?.paytmWalletTopupCount || 0 }} txns</div>
        </div>
        <div class="rg">
          <div class="rg-l">Shopping / POS</div>
          <div class="rg-v">{{ (bankStatementData.debitOutflowAnalysis?.shoppingOutflow || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">Lifestyle spend</div>
        </div>
        <div class="rg">
          <div class="rg-l">Utility / Telecom</div>
          <div class="rg-v">{{ (bankStatementData.debitOutflowAnalysis?.utilityOutflow || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">Fixed monthly</div>
        </div>
        <div class="rg" [style.background]="(bankStatementData.surplusRepayment?.monthlySurplusAmount || 0) >= 0 ? 'rgba(5,150,105,0.06)' : 'rgba(225,29,72,0.06)'">
          <div class="rg-l">Monthly Surplus</div>
          <div class="rg-v" [style.color]="(bankStatementData.surplusRepayment?.monthlySurplusAmount || 0) >= 0 ? 'var(--green)' : 'var(--rose)'">
            {{ (bankStatementData.surplusRepayment?.monthlySurplusAmount || 0) | currency:'INR':'symbol':'1.0-0' }}
          </div>
          <div class="rg-s">Income/Expense: {{ (bankStatementData.surplusRepayment?.incomeToExpenseRatio || 0) | number:'1.2-2' }}</div>
        </div>
      </div>
    </div>

    <!-- BALANCE HEALTH -->
    <div class="card">
      <div class="card-title">
        <div class="ct-bar" style="background:#0284c7;"></div>
        Balance Health
      </div>
      <div class="rg4">
        <div class="rg bv">
          <div class="rg-l">Avg Monthly Balance</div>
          <div class="rg-v">{{ (bankStatementData.balanceHealth?.averageMonthlyBalance || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">Median: {{ (bankStatementData.balanceHealth?.medianMonthlyBalance || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
        </div>
        <div class="rg gv">
          <div class="rg-l">Maximum Balance</div>
          <div class="rg-v">{{ (bankStatementData.balanceHealth?.maximumBalance || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">Peak</div>
        </div>
        <div class="rg" [style.background]="(bankStatementData.balanceHealth?.minimumBalance || 0) < 5000 ? 'rgba(225,29,72,0.06)' : ''">
          <div class="rg-l">Minimum Balance</div>
          <div class="rg-v">{{ (bankStatementData.balanceHealth?.minimumBalance || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">
            <span *ngIf="bankStatementData.balanceHealth?.lowBalanceDays > 0" style="color:var(--amber);">
              {{ bankStatementData.balanceHealth?.lowBalanceDays }} low-balance days
            </span>
            <span *ngIf="!bankStatementData.balanceHealth?.lowBalanceDays">✓ No low-balance days</span>
          </div>
        </div>
        <div class="rg" [style.background]="bankStatementData.balanceHealth?.negativeBalanceDays > 0 ? 'rgba(225,29,72,0.06)' : ''">
          <div class="rg-l">Negative Days</div>
          <div class="rg-v" [style.color]="bankStatementData.balanceHealth?.negativeBalanceDays > 0 ? 'var(--rose)' : 'var(--green)'">
            {{ bankStatementData.balanceHealth?.negativeBalanceDays || 0 }}
          </div>
          <div class="rg-s">Penalty count: {{ bankStatementData.balanceHealth?.minimumBalancePenaltyCount || 0 }}</div>
        </div>
      </div>
    </div>

    <!-- INCOME / SALARY TRUST -->
    <div class="card">
      <div class="card-title">
        <div class="ct-bar" style="background:#10b981;"></div>
        Income & Salary Analysis
      </div>
      <div class="rg4">
        <div class="rg" [style.background]="bankStatementData.salaryIncomeTrust?.salaryDetected ? 'rgba(5,150,105,0.06)' : 'rgba(217,119,6,0.06)'">
          <div class="rg-l">Salary Detected</div>
          <div class="rg-v" [style.color]="bankStatementData.salaryIncomeTrust?.salaryDetected ? 'var(--green)' : 'var(--amber)'">
            {{ bankStatementData.salaryIncomeTrust?.salaryDetected ? 'Yes' : 'No' }}
          </div>
          <div class="rg-s">Disbursement: {{ bankStatementData.salaryIncomeTrust?.salaryDisbursementDetected ? 'Yes' : 'No' }}</div>
        </div>
        <div class="rg gv">
          <div class="rg-l">Avg Monthly Salary</div>
          <div class="rg-v">{{ (bankStatementData.salaryIncomeTrust?.averageMonthlySalary || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">Median: {{ (bankStatementData.salaryIncomeTrust?.medianMonthlySalary || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
        </div>
        <div class="rg bv">
          <div class="rg-l">Income Trust Score</div>
          <div class="rg-v">{{ bankStatementData.salaryIncomeTrust?.incomeTrustScore || 0 }}/100</div>
          <div class="rg-s">Consistency score</div>
        </div>
        <div class="rg" [style.background]="bankStatementData.salaryIncomeTrust?.incomeDropMoreThan30Percent ? 'rgba(225,29,72,0.06)' : ''">
          <div class="rg-l">Income Drop > 30%</div>
          <div class="rg-v" [style.color]="bankStatementData.salaryIncomeTrust?.incomeDropMoreThan30Percent ? 'var(--rose)' : 'var(--green)'">
            {{ bankStatementData.salaryIncomeTrust?.incomeDropMoreThan30Percent ? 'Yes' : 'No' }}
          </div>
          <div class="rg-s">Volatility: {{ bankStatementData.salaryIncomeTrust?.incomeVolatilityPercentage || 0 | number:'1.1-1' }}%</div>
        </div>
      </div>

      <!-- Credit breakdown -->
      <div style="margin-top:16px">
        <div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:var(--txt3);margin-bottom:10px;">
          Credit Sources Breakdown
        </div>
        <div class="tbl-wrap">
          <table class="tbl">
            <thead>
              <tr>
                <th>Source</th>
                <th>Count</th>
                <th>Amount</th>
                <th>Share %</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cb of bankStatementData.creditBreakdown" [style.opacity]="cb.amount === 0 ? '0.35' : '1'">
                <td>{{ cb.source }}</td>
                <td>{{ cb.count }}</td>
                <td style="font-family:var(--mono);font-weight:600;">{{ cb.amount | currency:'INR':'symbol':'1.0-2' }}</td>
                <td>
                  <div style="display:flex;align-items:center;gap:6px;">
                    <div style="flex:1;background:#e5e7eb;height:6px;border-radius:3px;min-width:60px;">
                      <div [style.width.%]="cb.percentage" style="background:#10b981;height:6px;border-radius:3px;"></div>
                    </div>
                    <span style="font-size:11px;font-weight:600;color:var(--txt2);">{{ cb.percentage | number:'1.1-1' }}%</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- EXPENSE / EMI LIABILITY -->
    <div class="card">
      <div class="card-title">
        <div class="ct-bar" style="background:#f59e0b;"></div>
        Expense & EMI Liability
      </div>
      <div class="rg4">
        <div class="rg">
          <div class="rg-l">Fixed Expense</div>
          <div class="rg-v">{{ (bankStatementData.expenseStability?.fixedExpenseAmount || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">Monthly essential</div>
        </div>
        <div class="rg av">
          <div class="rg-l">Variable Expense</div>
          <div class="rg-v">{{ (bankStatementData.expenseStability?.variableExpenseAmount || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">Lifestyle + discretionary</div>
        </div>
        <div class="rg" [style.background]="(bankStatementData.expenseStability?.expenseStabilityScore || 0) < 40 ? 'rgba(225,29,72,0.06)' : ''">
          <div class="rg-l">Expense Stability</div>
          <div class="rg-v" [style.color]="(bankStatementData.expenseStability?.expenseStabilityScore || 0) < 40 ? 'var(--rose)' : 'var(--green)'">
            {{ bankStatementData.expenseStability?.expenseStabilityScore || 0 }}/100
          </div>
          <div class="rg-s">Volatility: {{ bankStatementData.expenseStability?.expenseVolatilityPercentage || 0 | number:'1.1-1' }}%</div>
        </div>
        <div class="rg" [style.background]="bankStatementData.emiLiabilityAnalysis?.hiddenLiabilitySuspected ? 'rgba(225,29,72,0.06)' : ''">
          <div class="rg-l">Hidden Liability</div>
          <div class="rg-v" [style.color]="bankStatementData.emiLiabilityAnalysis?.hiddenLiabilitySuspected ? 'var(--rose)' : 'var(--green)'">
            {{ bankStatementData.emiLiabilityAnalysis?.hiddenLiabilitySuspected ? 'Suspected' : 'None' }}
          </div>
          <div class="rg-s">Liability Stress: {{ bankStatementData.emiLiabilityAnalysis?.liabilityStressScore || 0 }}/100</div>
        </div>
      </div>

      <!-- EMI Details row -->
      <div class="rg4" style="margin-top:10px" *ngIf="bankStatementData.emiLiabilityAnalysis">
        <div class="rg">
          <div class="rg-l">EMI Count</div>
          <div class="rg-v">{{ bankStatementData.emiLiabilityAnalysis?.existingEmiCount || 0 }}</div>
          <div class="rg-s">Active loans</div>
        </div>
        <div class="rg av">
          <div class="rg-l">Monthly EMI Amt</div>
          <div class="rg-v">{{ (bankStatementData.emiLiabilityAnalysis?.existingMonthlyEmiAmount || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">Obligation</div>
        </div>
        <div class="rg" [style.background]="bankStatementData.emiLiabilityAnalysis?.emiBounceCount > 0 ? 'rgba(225,29,72,0.06)' : ''">
          <div class="rg-l">EMI Bounces</div>
          <div class="rg-v" [style.color]="bankStatementData.emiLiabilityAnalysis?.emiBounceCount > 0 ? 'var(--rose)' : 'var(--green)'">
            {{ bankStatementData.emiLiabilityAnalysis?.emiBounceCount || 0 }}
          </div>
          <div class="rg-s">Cheque: {{ bankStatementData.emiLiabilityAnalysis?.chequeBounceCount || 0 }} · NACH: {{ bankStatementData.emiLiabilityAnalysis?.nachReturnCount || 0 }}</div>
        </div>
        <div class="rg bv">
          <div class="rg-l">FOIR %</div>
          <div class="rg-v">{{ bankStatementData.foirAnalysis?.foirPercentage || 0 | number:'1.1-1' }}%</div>
          <div class="rg-s">Risk: {{ bankStatementData.foirAnalysis?.foirRiskLevel || '—' }}</div>
        </div>
      </div>

      <!-- Debit breakdown table -->
      <div style="margin-top:16px">
        <div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:var(--txt3);margin-bottom:10px;">
          Debit Breakdown by Category
        </div>
        <div class="tbl-wrap">
          <table class="tbl">
            <thead>
              <tr>
                <th>Category</th>
                <th>Count</th>
                <th>Amount</th>
                <th>Share %</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let db of bankStatementData.debitBreakdown" [style.opacity]="db.amount === 0 ? '0.35' : '1'">
                <td>{{ db.category }}</td>
                <td>{{ db.count }}</td>
                <td style="font-family:var(--mono);font-weight:600;color:#dc2626;">{{ db.amount | currency:'INR':'symbol':'1.0-2' }}</td>
                <td>
                  <div style="display:flex;align-items:center;gap:6px;">
                    <div style="flex:1;background:#e5e7eb;height:6px;border-radius:3px;min-width:60px;">
                      <div [style.width.%]="db.percentage" style="background:#f59e0b;height:6px;border-radius:3px;"></div>
                    </div>
                    <span style="font-size:11px;font-weight:600;color:var(--txt2);">{{ db.percentage | number:'1.1-1' }}%</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- CASH FLOW & ATM -->
    <div class="card">
      <div class="card-title">
        <div class="ct-bar" style="background:#e11d48;"></div>
        Cash Flow & ATM Withdrawals
      </div>
      <div class="rg4">
        <div class="rg">
          <div class="rg-l">Cash Deposits</div>
          <div class="rg-v">{{ (bankStatementData.cashFlowAnalysis?.cashDepositAmount || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">{{ bankStatementData.cashFlowAnalysis?.cashDepositCount || 0 }} deposits</div>
        </div>
        <div class="rg av">
          <div class="rg-l">ATM Withdrawals</div>
          <div class="rg-v">{{ (bankStatementData.cashFlowAnalysis?.cashWithdrawalAmount || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
          <div class="rg-s">{{ bankStatementData.cashFlowAnalysis?.cashWithdrawalCount || 0 }} txns</div>
        </div>
        <div class="rg">
          <div class="rg-l">W/D % of Debit</div>
          <div class="rg-v">{{ bankStatementData.cashFlowAnalysis?.cashWithdrawalRatioAgainstDebit || 0 | number:'1.1-1' }}%</div>
          <div class="rg-s">{{ bankStatementData.cashFlowAnalysis?.cashHeavyProfile ? '⚠ Cash heavy' : '✓ Normal' }}</div>
        </div>
        <div class="rg bv">
          <div class="rg-l">Repayment Capacity</div>
          <div class="rg-v">{{ bankStatementData.surplusRepayment?.repaymentCapacityScore || 0 }}/100</div>
          <div class="rg-s">Savings rate: {{ bankStatementData.surplusRepayment?.savingsRatePercentage || 0 | number:'1.1-1' }}%</div>
        </div>
      </div>

      <!-- ATM withdrawals table -->
      <div style="margin-top:16px" *ngIf="bankStatementData.atmWithdrawals?.length">
        <div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:var(--txt3);margin-bottom:10px;">
          ATM Withdrawal History
        </div>
        <div class="tbl-wrap">
          <table class="tbl">
            <thead>
              <tr>
                <th>Date</th>
                <th>Amount</th>
                <th>Balance After</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let atm of bankStatementData.atmWithdrawals">
                <td style="font-family:var(--mono);font-size:11px;white-space:nowrap;">{{ atm.transactionDate }}</td>
                <td style="color:#dc2626;font-weight:600;font-family:var(--mono);">{{ atm.debitAmount | currency:'INR':'symbol':'1.0-2' }}</td>
                <td style="font-family:var(--mono);font-size:11px;">{{ atm.runningBalance | currency:'INR':'symbol':'1.0-2' }}</td>
                <td style="font-size:11px;max-width:240px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" [title]="atm.description">{{ atm.description }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- UPI FLOW ANALYSIS -->
    <div class="card">
      <div class="card-title">
        <div class="ct-bar" style="background:#8b5cf6;"></div>
        UPI Transaction Analysis
        <span *ngIf="bankStatementData.upiFlowAnalysis?.upiCircularFlowSuspected"
          style="margin-left:8px;background:#fee2e2;color:#991b1b;padding:3px 8px;border-radius:4px;font-size:11px;font-weight:700;">
          🚨 Circular Flow Suspected
        </span>
      </div>
      <div class="rg4">
        <div class="rg gv">
          <div class="rg-l">UPI Net Flow</div>
          <div class="rg-v" [style.color]="(bankStatementData.upiFlowAnalysis?.upiNetFlow || 0) >= 0 ? 'var(--green)' : 'var(--rose)'">
            {{ (bankStatementData.upiFlowAnalysis?.upiNetFlow || 0) | currency:'INR':'symbol':'1.0-0' }}
          </div>
          <div class="rg-s">Inflow minus outflow</div>
        </div>
        <div class="rg">
          <div class="rg-l">Paytm Top-ups</div>
          <div class="rg-v">{{ bankStatementData.upiFlowAnalysis?.paytmWalletTopupCount || 0 }}</div>
          <div class="rg-s">{{ (bankStatementData.upiFlowAnalysis?.paytmWalletTopupAmount || 0) | currency:'INR':'symbol':'1.0-0' }}</div>
        </div>
        <div class="rg">
          <div class="rg-l">High Freq UPI Out</div>
          <div class="rg-v" [style.color]="bankStatementData.upiFlowAnalysis?.highFrequencyUpiOutflow ? 'var(--rose)' : 'var(--green)'">
            {{ bankStatementData.upiFlowAnalysis?.highFrequencyUpiOutflow ? 'Yes' : 'No' }}
          </div>
          <div class="rg-s">Frequency flag</div>
        </div>
        <div class="rg">
          <div class="rg-l">Self UPI Transfer</div>
          <div class="rg-v">{{ bankStatementData.upiFlowAnalysis?.selfUpiTransferDetected ? 'Detected' : 'None' }}</div>
          <div class="rg-s">Round-trip check</div>
        </div>
      </div>

      <!-- UPI transactions table -->
      <div style="margin-top:16px" *ngIf="bankStatementData.upiTransactions?.length">
        <div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:var(--txt3);margin-bottom:10px;">
          UPI Transaction Details
        </div>
        <div class="tbl-wrap">
          <table class="tbl">
            <thead>
              <tr>
                <th>Date</th>
                <th>Counterparty</th>
                <th>Category</th>
                <th>Debit</th>
                <th>Credit</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let upi of bankStatementData.upiTransactions"
                [style.background]="upi.creditAmount ? 'rgba(16,185,129,0.04)' : 'rgba(239,68,68,0.03)'">
                <td style="font-family:var(--mono);font-size:11px;white-space:nowrap;">{{ upi.transactionDate }}</td>
                <td style="font-size:12px;font-weight:500;">{{ upi.counterparty || '—' }}</td>
                <td><span class="ftag" style="background:var(--violet-l);color:var(--violet);">{{ upi.subCategory?.replace('_',' ') }}</span></td>
                <td style="color:#dc2626;font-weight:500;font-family:var(--mono);font-size:12px;">
                  {{ upi.debitAmount ? (upi.debitAmount | currency:'INR':'symbol':'1.0-2') : '—' }}
                </td>
                <td style="color:#059669;font-weight:500;font-family:var(--mono);font-size:12px;">
                  {{ upi.creditAmount ? (upi.creditAmount | currency:'INR':'symbol':'1.0-2') : '—' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- FLAGGED TRANSACTIONS -->
    <div class="card" *ngIf="bankStatementData.flaggedTransactions?.length"
      style="border-left:4px solid var(--rose);">
      <div class="card-title">
        <div class="ct-bar" style="background:var(--rose);"></div>
        🚨 Flagged Transactions
        <span style="margin-left:6px;background:#fee2e2;color:#b91c1c;padding:2px 8px;border-radius:4px;font-size:11px;font-weight:700;">
          {{ bankStatementData.flaggedTransactions.length }} flagged
        </span>
      </div>
      <div class="tbl-wrap">
        <table class="tbl">
          <thead>
            <tr>
              <th>Date</th>
              <th>Counterparty</th>
              <th>Category</th>
              <th>Debit</th>
              <th>Credit</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let f of bankStatementData.flaggedTransactions" style="background:rgba(225,29,72,0.04);">
              <td style="font-family:var(--mono);font-size:11px;white-space:nowrap;">{{ f.transactionDate }}</td>
              <td style="font-size:12px;font-weight:600;color:#b91c1c;">{{ f.counterparty || '—' }}</td>
              <td style="font-size:11px;">{{ f.subCategory?.replace('_',' ') }}</td>
              <td style="color:#dc2626;font-weight:600;font-family:var(--mono);font-size:12px;">
                {{ f.debitAmount ? (f.debitAmount | currency:'INR':'symbol':'1.0-2') : '—' }}
              </td>
              <td style="color:#059669;font-weight:600;font-family:var(--mono);font-size:12px;">
                {{ f.creditAmount ? (f.creditAmount | currency:'INR':'symbol':'1.0-2') : '—' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ALL TRANSACTIONS -->
    <div class="card">
      <div class="card-title">
        <div class="ct-bar" style="background:#8b5cf6;"></div>
        All Transactions
        <span style="font-size:11px;color:var(--txt3);margin-left:6px;">
          · {{ bankStatementData.transactions?.length || 0 }} total
        </span>
        <button class="btn btn-sm btn-out" style="margin-left:auto;"
          (click)="showAllTransactions = !showAllTransactions">
          {{ showAllTransactions ? 'Show Less ↑' : 'Show All ↓' }}
        </button>
      </div>
      <div class="tbl-wrap">
        <table class="tbl">
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Mode</th>
              <th>Category</th>
              <th>Debit</th>
              <th>Credit</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tx of (showAllTransactions ? bankStatementData.transactions : (bankStatementData.transactions | slice:0:10))"
              [style.background]="tx.transactionType === 'CREDIT' ? 'rgba(16,185,129,0.04)' : 'rgba(239,68,68,0.03)'">
              <td style="font-family:var(--mono);font-size:11px;white-space:nowrap;">{{ tx.transactionDate }}</td>
              <td style="font-size:11px;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" [title]="tx.description">{{ tx.description }}</td>
              <td>
                <span class="ftag"
                  [style.background]="tx.paymentMode === 'UPI' ? '#ede9fe' : tx.paymentMode === 'ATM' ? '#fee2e2' : tx.paymentMode === 'NEFT' ? '#dbeafe' : '#e0f2fe'"
                  style="color:var(--txt1);">
                  {{ tx.paymentMode }}
                </span>
              </td>
              <td style="font-size:11px;">{{ tx.subCategory?.replace('_',' ') }}</td>
              <td style="color:#dc2626;font-weight:500;font-size:12px;font-family:var(--mono);">
                {{ tx.debitAmount ? (tx.debitAmount | currency:'INR':'symbol':'1.0-2') : '—' }}
              </td>
              <td style="color:#059669;font-weight:500;font-size:12px;font-family:var(--mono);">
                {{ tx.creditAmount ? (tx.creditAmount | currency:'INR':'symbol':'1.0-2') : '—' }}
              </td>
              <td style="font-size:11px;font-family:var(--mono);">
                {{ tx.runningBalance | currency:'INR':'symbol':'1.0-2' }}
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="!showAllTransactions && (bankStatementData.transactions?.length || 0) > 10"
          style="padding:10px;text-align:center;font-size:12px;color:var(--txt3);cursor:pointer;border-top:1px solid var(--bdr);"
          (click)="showAllTransactions = true">
          Showing 10 of {{ bankStatementData.transactions?.length }} — click "Show All" to expand
        </div>
      </div>
    </div>

  </ng-container>

  <!-- ══ EMPLOYMENT & INCOME ══ -->
  <div class="card">
    <div class="card-title">
      <div class="ct-bar"></div>
      Employment & Income Details
    </div>
    <div class="fg" style="gap:13px">
      <div class="fl">
        <label>Occupation type <span class="req">*</span></label>
        <div class="pill-row">
          <label class="pill" *ngFor="let opt of occupationOptions"
            [class.sel]="occupation === opt" (click)="occupation = opt">
            <input type="radio" name="occ">{{ opt }}
          </label>
        </div>
      </div>

      <div class="fg c2">
        <div class="fl">
          <label>Monthly income (₹) <span class="req">*</span></label>
          <input type="number" [(ngModel)]="monthlyIncome" placeholder="Monthly net income">
          <span class="hint" *ngIf="bankStatementData && bankStatementData.creditInflowAnalysis?.averageMonthlyCredit > 0">
            Avg monthly credit from statement: {{ (bankStatementData.creditInflowAnalysis?.averageMonthlyCredit || 0) | currency:'INR':'symbol':'1.0-0' }}
          </span>
        </div>
        <div class="fl">
          <label>Employer / Business name</label>
          <input type="text" [(ngModel)]="employerName" placeholder="Employer or business name">
        </div>
        <div class="fl">
          <label>Employment type</label>
          <select [(ngModel)]="employmentType">
            <option value="">Select…</option>
            <option>Full-time</option>
            <option>Part-time</option>
            <option>Contract</option>
            <option>Freelance</option>
          </select>
        </div>
        <div class="fl">
          <label>Years at current job / business</label>
          <select [(ngModel)]="yearsAtJob">
            <option value="">Select…</option>
            <option *ngFor="let y of yearsOptions">{{ y }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- ══ BANK ACCOUNT FOR MANDATE ══ -->
  <div class="card">
    <div class="card-title">
      <div class="ct-bar"></div>
      Bank Account for Mandate
      <span class="ftag ft-api" style="margin-left:4px">Penny-drop verified</span>
      <span *ngIf="bankStatementData" class="ftag ft-auto" style="margin-left:4px">Auto-filled from statement</span>
    </div>
    <div class="fg c2">
      <div class="fl">
        <label>Account number</label>
        <input type="text" [(ngModel)]="accountNumber" placeholder="Bank account number" style="font-family:var(--mono)">
      </div>
      <div class="fl">
        <label>IFSC code</label>
        <div class="iw">
          <input type="text" [(ngModel)]="ifscCode" style="font-family:var(--mono)" placeholder="e.g. SBIN0001234">
          <button class="ib sec" (click)="lookupBank()">Lookup</button>
        </div>
      </div>
      <div class="fl" *ngIf="bankBranch">
        <label>Bank + branch <span class="ftag ft-auto">READ-ONLY</span></label>
        <input class="inp-af inp-ro" type="text" [value]="bankBranch" readonly>
      </div>
      <div class="fl" *ngIf="accountHolder">
        <label>Account holder <span class="ftag ft-api">Penny-drop</span></label>
        <input class="inp-af inp-ro" type="text" [value]="accountHolder" readonly>
      </div>
    </div>
  </div>

  <!-- ══ NAVIGATION ══ -->
  <div class="nav-bar">
    <button class="btn btn-sec" (click)="prev.emit()">← Back</button>
    <button class="btn btn-pri btn-lg" (click)="saveFinancialDetails()" [disabled]="!isValid || isSaving">
      <span *ngIf="!isSaving">Save & Continue →</span>
      <span *ngIf="isSaving">
        <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        Saving…
      </span>
    </button>
  </div>

</div>